export const FORM_NAMES = {
    oldPAssword: "oldPAssword",
    newPassword: "newPassword",
    reNewPassword: "reNewPassword"
} as const